var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-detail"},[_c('div',{staticClass:"table-content"},[_c('DetailBill')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }